import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7773669b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 2 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "red" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("/")
const _hoisted_6 = { class: "green" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick", "src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "ybtitle-tooltip" }
const _hoisted_11 = ["id", "onClick"]
const _hoisted_12 = { class: "ybtitle-tooltip" }
const _hoisted_13 = ["id", "onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("下载 ")
const _hoisted_16 = { class: "spotColor" }
const _hoisted_17 = {
  key: 0,
  class: "heightarr"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "heightarr"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "heightarr"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  class: "heightarr"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { style: {"margin":"0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_ArrowUpOutlined = _resolveComponent("ArrowUpOutlined")!
  const _component_ArrowDownOutlined = _resolveComponent("ArrowDownOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_VerticalAlignBottomOutlined = _resolveComponent("VerticalAlignBottomOutlined")!
  const _component_CaretDownOutlined = _resolveComponent("CaretDownOutlined")!
  const _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    columns: _ctx.columns,
    "data-source": _ctx.data,
    class: _normalizeClass(_ctx.theme),
    bordered: _ctx.bordered,
    pagination: _ctx.pagination,
    "row-key": 'index',
    scroll: _ctx.scroll,
    "expanded-row-keys": _ctx.expandedRowKeys,
    customRow: _ctx.customRow,
    "row-class-name": _ctx.setRowClassName,
    "custom-cell": _ctx.handleClickRow,
    size: "small",
    onExpand: _ctx.onExpand,
    onChange: _ctx.onChange
  }, _createSlots({
    rankColor: _withCtx(({ record }) => [
      (record.index !== undefined)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(record.index === 0 ? 'rank-first' : record.index === 1 ? 'rank-second' : record.index === 2 ? 'rank-third' : '')
          }, _toDisplayString(record.index + 1), 3))
        : (record.rank !== undefined)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(record.rank === 1 ? 'rank-first' : record.rank === 2 ? 'rank-second' : record.rank === 3 ? 'rank-third' : '')
            }, _toDisplayString(record.rank), 3))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(record.index || record.rank || '--'), 1))
    ]),
    name: _withCtx(({ text }) => [
      _createElementVNode("a", null, _toDisplayString(text), 1)
    ]),
    Index: _withCtx(({ index }) => [
      _createElementVNode("span", null, _toDisplayString(index + 1), 1)
    ]),
    bkName: _withCtx(({ text, record }) => [
      _createElementVNode("div", null, _toDisplayString(text), 1),
      (record.labels && record.labels.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(record.labels, (item) => {
            return (_openBlock(), _createBlock(_component_a_tag, {
              color: "#f50",
              key: item,
              style: {"margin":"4px 2px 0px 0px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    stockName: _withCtx(({ text, record }) => [
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.marginStyle ? 'margin: 0px' : 'margin: 0px 0px 5px 3px')
      }, _toDisplayString(text), 5),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.marginStyle ? 'margin: 0px' : 'margin: 0px 0px 5px 3px')
      }, _toDisplayString(record.symbol), 5)
    ]),
    changeRank: _withCtx(({ text }) => [
      _createElementVNode("div", {
        style: _normalizeStyle(text > 0 ? 'color:red' : text < 0 ? 'color:green' : '')
      }, [
        _createElementVNode("span", null, _toDisplayString(text===undefined || text===null ? '--' : text), 1),
        (text > 0)
          ? (_openBlock(), _createBlock(_component_ArrowUpOutlined, { key: 0 }))
          : (text < 0)
            ? (_openBlock(), _createBlock(_component_ArrowDownOutlined, { key: 1 }))
            : _createCommentVNode("", true)
      ], 4)
    ]),
    riseFirstGrpName: _withCtx(({ record }) => [
      _createElementVNode("span", null, _toDisplayString(record?.riseFirstGrp && record?.riseFirstGrp?.name ? record?.riseFirstGrp?.name : '--'), 1)
    ]),
    riseFirstGrpRise: _withCtx(({ record }) => [
      (record?.riseFirstGrp)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([record.riseFirstGrp.pxChangeRate > 0 ? 'red' : record.riseFirstGrp.pxChangeRate < 0 ? 'green' : ''])
          }, _toDisplayString(record.riseFirstGrp.pxChangeRate != null ? (record.riseFirstGrp.pxChangeRate * 100).toFixed(2) + '%' : '--'), 3))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "--"))
    ]),
    riseAFall: _withCtx(({ record }) => [
      (record.riseCount != null && record.fallCount != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(record.riseCount ? record.riseCount : 0), 1),
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(record.fallCount ?
          record.fallCount : record.fallCount), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, "--"))
    ]),
    pdf: _withCtx(({ text }) => [
      text
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            onClick: ($event: any) => (_ctx.openPdf(text)),
            src: require("@/assets/pdf.png"),
            style: {"cursor":"pointer"}
          }, null, 8, _hoisted_8))
        : (_openBlock(), _createElementBlock("span", _hoisted_9, "--"))
    ]),
    advice: _withCtx(({ text }) => [
      _createElementVNode("span", null, _toDisplayString(text ? text : '--'), 1)
    ]),
    ellipsis: _withCtx(({ record, text, index, column }) => [
      _createVNode(_component_a_popover, {
        placement: "topLeft",
        visible: _ctx.overflow[column.key + record.index],
        align: {
        offset: [0, 4]
      },
        "mouse-enter-delay": 0.4,
        overlayClassName: 'imitatetitletooltip',
        "get-popup-container": _ctx.getPopupContainer,
        onVisibleChange: ($event: any) => (_ctx.visibleChange($event, (column.key + record.index)))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, _toDisplayString(text), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "overflow",
            href: "javascript:void(0)",
            id: column.key + record.index,
            onClick: ($event: any) => (_ctx.showdrawer(record, column))
          }, _toDisplayString(text ? text : '—'), 9, _hoisted_11)
        ]),
        _: 2
      }, 1032, ["visible", "mouse-enter-delay", "get-popup-container", "onVisibleChange"])
    ]),
    link: _withCtx(({ record, text, index, column }) => [
      _createVNode(_component_a_popover, {
        placement: "topLeft",
        visible: _ctx.overflow[column.key + record.index],
        align: {
        offset: [0, 4]
      },
        "destroy-tooltip-on-hide": "",
        "mouse-enter-delay": 0.4,
        overlayClassName: 'imitatetitletooltip',
        "get-popup-container": _ctx.getPopupContainer,
        onVisibleChange: ($event: any) => (_ctx.visibleChange($event, (column.key + record.index)))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, _toDisplayString(text), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "overflow",
            id: column.key + record.index,
            href: "javascript:void(0)",
            onClick: ($event: any) => (_ctx.gotolink($event, record, column))
          }, _toDisplayString(text || '—'), 9, _hoisted_13)
        ]),
        _: 2
      }, 1032, ["visible", "mouse-enter-delay", "get-popup-container", "onVisibleChange"])
    ]),
    increase: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        class: _normalizeClass([text > 0 ? 'red' : text < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getPencent(text)), 3)
    ]),
    nocolorincrease: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getPencent(text)), 5)
    ]),
    decimal: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(parseFloat(text).toString() !== 'NaN' ? (text || 0).toFixed(2) : '—'), 5)
    ]),
    decimal4: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(parseFloat(text).toString() !== 'NaN' ? (text || 0).toFixed(4) : '—'), 5)
    ]),
    peopleCount: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getNumber(text)), 5)
    ]),
    peopleCountFixed2: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getNumber2(text)), 5)
    ]),
    download: _withCtx(({ record, text, column }) => [
      _createElementVNode("a", {
        class: "download",
        onClick: ($event: any) => (_ctx.gotolink($event, record, column)),
        href: "javascript:;"
      }, [
        _createVNode(_component_VerticalAlignBottomOutlined),
        _hoisted_15
      ], 8, _hoisted_14)
    ]),
    peopleCountColor: _withCtx(({ text }) => [
      _createElementVNode("span", {
        class: _normalizeClass([text > 0 ? 'red' : text < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getNumber(text)), 3)
    ]),
    spotColor: _withCtx(({ record, text }) => [
      _createElementVNode("div", _hoisted_16, [
        _createTextVNode(_toDisplayString(text || ''), 1),
        (record.color)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              style: _normalizeStyle({ background: record.color })
            }, null, 4))
          : _createCommentVNode("", true)
      ])
    ]),
    RLnocolorincrease: _withCtx(({ record, text, column }) => [
      (_ctx.theme !== 'dark')
        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
            (record['height' + column.key] === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/top_light.png'),
                  alt: ""
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true),
            (record['height' + column.key] === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/bottom_light.png'),
                  alt: ""
                }, null, 8, _hoisted_19))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_20, [
            (record['height' + column.key] === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/top_light.png'),
                  alt: ""
                }, null, 8, _hoisted_21))
              : _createCommentVNode("", true),
            (record['height' + column.key] === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/bottom_dark.png'),
                  alt: ""
                }, null, 8, _hoisted_22))
              : _createCommentVNode("", true)
          ])),
      _createTextVNode(" " + _toDisplayString(parseFloat(text).toString() !== 'NaN' ? (text || 0).toFixed(2) : '—'), 1)
    ]),
    RLpeopleCount: _withCtx(({ record, text, column }) => [
      (_ctx.theme !== 'dark')
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
            (record['height' + column.key] === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/top_light.png'),
                  alt: ""
                }, null, 8, _hoisted_24))
              : _createCommentVNode("", true),
            (record['height' + column.key] === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/bottom_light.png'),
                  alt: ""
                }, null, 8, _hoisted_25))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_26, [
            (record['height' + column.key] === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/top_light.png'),
                  alt: ""
                }, null, 8, _hoisted_27))
              : _createCommentVNode("", true),
            (record['height' + column.key] === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/bottom_dark.png'),
                  alt: ""
                }, null, 8, _hoisted_28))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("span", null, _toDisplayString(_ctx.getNumber(text)), 1)
    ]),
    _: 2
  }, [
    (_ctx.expandedRowRender)
      ? {
          name: "expandedRowRender",
          fn: _withCtx(({ record }) => [
            _createElementVNode("p", _hoisted_29, _toDisplayString(record.description), 1)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.expandedRowRender)
      ? {
          name: "expandIcon",
          fn: _withCtx((props) => [
            (props.expanded)
              ? (_openBlock(), _createBlock(_component_CaretDownOutlined, {
                  key: 0,
                  onClick: ($event: any) => (_ctx.clickexpandIcon(props))
                }, null, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_CaretRightOutlined, {
                  key: 1,
                  onClick: ($event: any) => (_ctx.clickexpandIcon(props))
                }, null, 8, ["onClick"]))
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["columns", "data-source", "class", "bordered", "pagination", "scroll", "expanded-row-keys", "customRow", "row-class-name", "custom-cell", "onExpand", "onChange"]))
}